import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderThree from "../components/HeaderThree";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import ScrollToTop from "react-scroll-to-top";

const PrivacyPolicyPage = () => {
    return (
        <>
            <ColorInit color={true} />
            <ScrollToTop smooth color="var(--brand-primary)" />
            <Preloader />
            <HeaderThree />
            <Breadcrumb title={"Privacy Policy"} />

            <section className="py-80 bg-white">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="privacy-content space-y-32">
                                <div>
                                    <h4 className="fw-bold mb-16">1. Introduction</h4>
                                    <p className="text-gray-600 leading-relaxed">
                                        Welcome to Vedha&apos;s Culture. We are committed to protecting your personal information and your right to privacy. 
                                        This Privacy Policy explains how we collect, use, store, and safeguard your information when you visit our website or make a purchase.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="fw-bold mb-16">2. Information We Collect</h4>
                                    <p className="text-gray-600 leading-relaxed mb-12">
                                        We collect personal information that you voluntarily provide to us when you:
                                    </p>
                                    <ul className="list-disc ps-24 text-gray-600 space-y-8">
                                        <li>Register on our website or place an order</li>
                                        <li>Participate in workshops or events</li>
                                        <li>Subscribe to our newsletter</li>
                                        <li>Contact us for support or inquiries</li>
                                    </ul>
                                    <p className="text-gray-600 leading-relaxed mt-12">
                                        This may include your name, email address, phone number, shipping address, billing information, and payment details.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="fw-bold mb-16">3. How We Use Your Information</h4>
                                    <p className="text-gray-600 leading-relaxed mb-12">
                                        We use the information we collect to:
                                    </p>
                                    <ul className="list-disc ps-24 text-gray-600 space-y-8">
                                        <li>Process and fulfill your orders</li>
                                        <li>Communicate with you about your orders and account</li>
                                        <li>Send you promotional emails and updates (with your consent)</li>
                                        <li>Improve our website, products, and services</li>
                                        <li>Comply with legal obligations</li>
                                    </ul>
                                </div>

                                <div>
                                    <h4 className="fw-bold mb-16">4. Data Security</h4>
                                    <p className="text-gray-600 leading-relaxed">
                                        We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, 
                                        alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="fw-bold mb-16">5. Sharing Your Information</h4>
                                    <p className="text-gray-600 leading-relaxed">
                                        We do not sell or rent your personal information to third parties. We may share your information with trusted service providers 
                                        (such as payment processors and shipping partners) solely to perform services on our behalf.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="fw-bold mb-16">6. Cookies</h4>
                                    <p className="text-gray-600 leading-relaxed">
                                        We use cookies to enhance your browsing experience, analyze site traffic, and understand where our visitors are coming from. 
                                        You can choose to disable cookies through your browser settings.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="fw-bold mb-16">7. Your Rights</h4>
                                    <p className="text-gray-600 leading-relaxed">
                                        You have the right to access, update, or delete your personal information. If you wish to exercise these rights, 
                                        please contact us at <a href="mailto:culturevedhas@gmail.com" className="text-main-600 hover-text-main-700">culturevedhas@gmail.com</a>.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="fw-bold mb-16">8. Changes to This Policy</h4>
                                    <p className="text-gray-600 leading-relaxed">
                                        We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="fw-bold mb-16">9. Contact Us</h4>
                                    <p className="text-gray-600 leading-relaxed">
                                        If you have any questions about this Privacy Policy, please contact us at:
                                    </p>
                                    <p className="text-gray-600 leading-relaxed mt-8">
                                        <strong>Email:</strong> <a href="mailto:culturevedhas@gmail.com" className="text-main-600 hover-text-main-700">culturevedhas@gmail.com</a><br />
                                        <strong>Phone:</strong> <a href="tel:9940075399" className="text-main-600 hover-text-main-700">+91 99400 75399</a><br />
                                        <strong>Address:</strong> 123, Sakthinagar 4th cross left, Thindal, Erode
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default PrivacyPolicyPage;
